import api from 'api';
import storage from "@/cflow/storageService";

class ordemService {

    upload(files) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.defaults.headers['Content-Type'] = 'multipart/form-data'
            var formData = new FormData();
            files.forEach(function(item, key){
                formData.append('file-' + key, item);
            })
            api.post('/upload?token='+user.token, formData).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    solicitar(dados) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.defaults.headers['Content-Type'] = 'application/json'
            api.post('/ordemServico?token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    atualizar(dados,id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.defaults.headers['Content-Type'] = 'application/json'
            api.put('/ordemServico/'+id+'?token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    listar(dados, skip) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/ordemServico/filter?skip='+skip+'&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/ordemServico/'+id+'?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    mudarStatus(id,status) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.put('/ordemServico/'+id+'/status?token='+user.token,{ status: status }).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    opcoesFiltro() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/ordemServico/filtros?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    buscarRelatorio(dados) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/ordemServico/report?token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    imprimir(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/ordemServico/imprimir/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    listarRelatorio(from, to, skip, dentista = 0, getDenList = 0) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/ordemServico/relatorio/solicitacoes?from='+from+'&to=' + to + '&skip=' + skip + '&idDen=' + dentista + '&getDenList=' + getDenList + '&token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    imprimirRelatorio(from, to, skip, dentista = 0) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/ordemServico/relatorio/solicitacoes?imprimir=1&from='+from+'&to=' + to + '&skip=' + skip + '&idDen=' + dentista + '&token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    listarServicosParaPagar(idxs, print = false) {
        print = print === true ? '&imprimir=1' : '';

        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/ordemServico/relatorio/pagamentos/' + idxs + '?token='+user.token+print).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    upload2(files) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.defaults.headers['Content-Type'] = 'multipart/form-data'
            var formData = new FormData();
            files.forEach(function(item, key){
                formData.append('file-' + key, item);
            })
            api.post('/upload?token='+user.token, formData).then((result) => {
                api.defaults.headers['Content-Type'] = 'application/json'
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvarPagamento(idxs, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/ordemServico/relatorio/pagamentos/' + idxs + '?token='+user.token, form).then((result) => {
                if(result.status == 200) resolve(result.data);
                if(result.status !== 200) reject(result);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new ordemService();